export const formatDateTime = (time: string | number | Date) => {
  const date = new Date(time);
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  // @ts-expect-error yse
  return new Intl.DateTimeFormat('en-GB', options).format(date);
};

export const formatTime = (time?: string | number | Date) => {
  if (!time) return '';
  return new Date(time).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const validateHours = (hours: string) => {
  const regex = /^([01]\d|2[0-3])/;
  return regex.test(hours);
};

export const validateMinutes = (minutes: string) => {
  const regex = /^([0-5]\d)/;
  return regex.test(minutes);
};

export const checkIfTimeIsInThePast = (givenTime: Date, currentDate: Date, givenDate?: Date) => {
  return (
    givenDate &&
    givenDate < currentDate &&
    givenTime.getTime() < currentDate.getTime() &&
    givenTime.getTime() !== currentDate.getTime()
  );
};

export const formatMinuteString = (number: number) => {
  if (number === 1) return `${number} min`;
  return `${number} mins`;
};

export const formatDateString = (date: Date, weekday = true) => {
  if (!date) return;
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  // @ts-expect-error waaa
  if (weekday) options.weekday = 'short';
  // @ts-expect-error waaa
  return new Date(date).toLocaleString(['en-gb'], options).replace(/,/g, '');
};
